module.exports = __webpack_public_path__ + "img/gratitude-journal_B095LFLR58.e6d79ba1.jpg";